import { render, staticRenderFns } from "./TableHeaderBase.vue?vue&type=template&id=6d48399f&scoped=true&lang=pug"
import script from "./TableHeaderBase.vue?vue&type=script&lang=ts"
export * from "./TableHeaderBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d48399f",
  null
  
)

export default component.exports